<template>
    <div v-show="isVisible"
         v-if="isVisible"
         :id="['tagForm-' +  fields.formID]">
        <KeepAlive>
            <component :is="templateForm.template"
                       :store="store"
                       :configuration-data="elementSelected?.configurationData"
                       :formDescription="form.description"
                       :formSizeClass="'large-form-modal-container'"
                       :formTitle="form.title"
                       :identifierId="fields.formID"
                       :key="templateForm._uid"
                       :translateLabels="translateLabels"
                       :typeIdentifier="'form'"
                       @setClose="closeModal"
            ></component>
        </KeepAlive>
    </div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue';
import { v1 as uuidv1 } from 'uuid';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import templateDefault from './templates/template-default.vue';
import template2 from './templates/template-2.vue';
import template3 from './templates/template-3.vue';
import template4 from './templates/template-4.vue';
import template5 from './templates/template-5.vue';
import template6 from './templates/template-6.vue';
import template7 from './templates/template-7.vue';
import template8 from './templates/template-8.vue';

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS
const props = defineProps({
    form: {
        type: Object,
        required: true,
    },
    translateLabels: {
        type: Object,
        required: true,
    },
});

// COMPONENTS
const templateComponents = {
    'template-default': templateDefault,
    'template2': template2,
    'template3': template3,
    'template4': template4,
    'template5': template5,
    'template6': template6,
    'template7': template7,
    'template8': template8,
};

// REACTIVE VARIABLES
const elementSelected = ref(null);

const fields = ref({
    vID: store.getVideoID,
    wlID: store.getWeblinkID,
    formID: store.getFormID,
    hotspotID: 0,
    hotspotEmailTemplateID: 0,
    formIsFromAttrAdditional: false,
});

// COMPUTED PROPERTIES
const isVisible = computed(() => {
    if (store.getFormData
        && store.getFormClickedFromSidebarData
        && store.getFormData.formId == Number(store.getFormClickedFromSidebarData.customAction)
    ) {
        elementSelected.value = store.getFormClickedFromSidebarData;
        return true;
    }
    $('#bottom-button-bar').css({
        opacity: 1, bottom: -50, padding: 0, transition: '0.3s',
    });

    return false;
});

const templateForm = computed(() => {
    let templateComponent = templateDefault; // Default fallback
    let templateKey = 'template-default';

    // Si hay un template específico configurado
    if (elementSelected.value && elementSelected.value.templateForms) {
        templateKey = elementSelected.value.templateForms.skeletonHtml;
        templateComponent = templateComponents[templateKey] || templateDefault;
    }

    return {
        template: templateComponent,
        _uid: uuidv1(),
    };
});

// METHODS
const closeModal = () => {
    $('#bottom-button-bar').css({opacity: 1, bottom: -1, transition: '0.3s'});
    elementSelected.value = null;
    store.setFormClickedFromSidebarData({data: null});
};

// LIFECYCLE HOOKS
// todo: borrar
// onMounted(() => {
//     if (store.getFormData && store.getFormData.questions) {
//         let questionData = {
//             'id': fields.value.formID,
//             'type': 'form',
//             'data': store.getFormData.questions
//         }
//         store.setFormQuestions(questionData);
//     }
// });
</script>
